const FNV_OFFSET_BASIS_32 = 0x811c9dc5;
const FNV_PRIME_32 = 0x01000193;

/**
 * FNV-1a 32-bit hash. Used for event-ID dedup and variant bucketing.
 */
export const fnv1a32 = (input: string): number => {
  let hash = FNV_OFFSET_BASIS_32;
  for (let i = 0; i < input.length; i += 1) {
    hash ^= input.charCodeAt(i);
    hash = Math.imul(hash, FNV_PRIME_32);
  }
  return hash >>> 0;
};
